import { useDataValue } from 'Simple/Data.js'
import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  let tab = useDataValue({
    context: 'tab',
    path: 'selected.statements.old',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return tab || data
  }, [])
}
